import { Figure } from "components/Figure"
import { HeartRegular } from "components/Icon"
import { useTranslator } from "components/Translator"

export const LikesCounter = ({ nbLikes }) => {
  const translator = useTranslator()
  return (
    <Figure
      icon={<HeartRegular className="w-4" />}
      label={translator.trans("LikesCounter.label", { nbLikes }, "components")}
    />
  )
}
